<template>
    <van-popup
        v-if="changeSalesPersonPopupShow"
        :value="changeSalesPersonPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container customer_allocation_wrap" v-loading="loading">
            <div class="returnNavBar">
                <div class="returnNavBarLeft" @click="handleClickClose">
                    <van-icon name="arrow-left" />
                    <span class="normal_title">返回</span>
                </div>
            </div>
            <div class="mobile_container">
                <van-form
                    label-width="9.5em"
                    input-align="right"
                    scroll-to-error
                    :show-error-message="false"
                    ref="customerForm"
                    class=""
                >
                    <van-field
                        required
                        v-model="formData.salesperson_name"
                        name="更换为"
                        label="更换为"
                        placeholder="请选择"
                        is-link
                        readonly
                        @click="handleClickSelectUser"
                        :rules="[{ required: true, message: '请选择' }]"
                    >
                    </van-field>
                </van-form>
                <div class="operate_customer_list_box">
                    <div class="operate_customer_list_box_title">更换以下客户负责人</div>
                    <ul class="operate_customer_list">
                        <li v-for="item in companyList" :key="item.id">
                            <p class="ellipsis">{{ item.name && item.name.value }}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="add_footer_wrap">
                <van-button round block type="info" @click="handleClickConfirm">确定</van-button>
            </div>
            <UserSearchSelect
                :userSelectVisible.sync="userSelectVisible"
                :userSelectTitle="'更换为'"
                @selectUserData="handleSelectUserData"
                v-if="userSelectVisible"
            />
        </div>
    </van-popup>
</template>

<script>
import { UpdateCustomerPrivateSalesperson } from "@/api";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
export default {
    name: "CustomerDirectorChange",
    props: {
        changeSalesPersonPopupShow: {
            type: Boolean,
            default: false,
        },
        companyList: {
            type: Array,
            default: []
        }
    },
    components: { UserSearchSelect },
    data() {
        return {
            loading: false,
            formData: {
                salesperson: "",
                salesperson_name: "",
            },
            userSelectVisible: false,
        };
    },
    created() {
    },
    methods: {
        handleClickClose() {
            this.$emit("update:changeSalesPersonPopupShow", false)
        },
        handleClickSelectUser() {
            this.userSelectVisible = true;
        },
        handleSelectUserData(data) {
            console.log(data);
            this.formData.salesperson = data.uid;
            this.formData.salesperson_name = data.name;
        },
        handleClickConfirm() {
            this.$refs.customerForm.validate().then(() => {
                this.loading = true;
                const params = {
                    salesperson: this.formData.salesperson,
                    customer_ids: this.companyList.map((item) => item.id),
                };
                UpdateCustomerPrivateSalesperson(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$emit("update:changeSalesPersonPopupShow", false)
                                    this.$emit("changeSuccess")
                                },
                            });
                        } else {
                            this.$toast({
                                message: res.message,
                                type: "fail",
                            });
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/customers.scss";
.customer_allocation_wrap {
    .mobile_container {
        padding: 10px 16px;
    }
}
</style>
